module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.passengers), function(passenger) {
    return _c('div', {
      staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
    }, [_c('div', {
      staticClass: "card paper"
    }, [_c('div', {
      staticClass: "card-head"
    }, [_c('h3', [_vm._v(_vm._s(passenger.firstname))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "card-content padding-top"
    }, [_c('h4', [_vm._v("Algemeen")]), _vm._v(" "), _vm._l((_vm.getGeneralNotes(passenger)), function(note, index) {
      return _c('div', {
        staticClass: "card-row"
      }, [_c('div', {
        staticClass: "col-xs-3 col-sm-3 col-md-3 col-lg-3"
      }, [_c('span', [_vm._v(_vm._s(index))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-9 col-sm-9 col-md-9 col-lg-9"
      }, [(note) ? _c('span', [_vm._v(_vm._s(note))]) : _c('span', [_vm._v("-")])])])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "card-content padding-top"
    }, [_c('h4', [_vm._v("Preferenties")]), _vm._v(" "), _vm._l((_vm.getPreferenceNotes(passenger)), function(note, index) {
      return _c('div', {
        staticClass: "card-row"
      }, [_c('div', {
        staticClass: "col-xs-3 col-sm-3 col-md-3 col-lg-3"
      }, [_c('span', [_vm._v(_vm._s(index))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-9 col-sm-9 col-md-9 col-lg-9"
      }, [(note) ? _c('span', [_vm._v(_vm._s(note))]) : _c('span', [_vm._v("-")])])])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "card-content padding-top"
    }, [_c('h4', [_vm._v("Essenties")]), _vm._v(" "), _vm._l((_vm.getEssentialNotes(passenger)), function(note, index) {
      return _c('div', {
        staticClass: "card-row"
      }, [_c('div', {
        staticClass: "col-xs-3 col-sm-3 col-md-3 col-lg-3"
      }, [_c('span', [_vm._v(_vm._s(index))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-9 col-sm-9 col-md-9 col-lg-9"
      }, [(note) ? _c('span', [_vm._v(_vm._s(note))]) : _c('span', [_vm._v("-")])])])
    })], 2)])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b47abc8"}!./src/templates/reservations/preferences.html
// module id = 548
// module chunks = 1